import { Action } from 'redux';
import { select, put } from 'redux-saga/effects';
import { AppState, ErrorAction } from 'store';
import { CardPaymentStateModel, PaymentDetailsModel } from 'models/Payment';
import { PaymentActionTypes, PaymentActions } from '../';
import { ACTION_CREATOR_NAME, userHelper, errorToBasketErrorModel } from 'helpers';
import { api } from 'repositories/api';
import { BasketSagaReturnType } from 'store/sagaHelpers';

export interface UpdateCardPaymentAction extends Action<PaymentActionTypes.UPDATE_CARD_PAYMENT> {
    cardPaymentState: CardPaymentStateModel;
}

export interface UpdateCardPaymentActionStart extends Action<PaymentActionTypes.UPDATE_CARD_PAYMENT_START> {
}

export interface UpdateCardPaymentActionSuccess extends Action<PaymentActionTypes.UPDATE_CARD_PAYMENT_SUCCESS> {
    cardPaymentState: CardPaymentStateModel;
    paymentDetails: PaymentDetailsModel;
}

export interface UpdateCardPaymentActionError extends ErrorAction<PaymentActionTypes.UPDATE_CARD_PAYMENT_ERROR> {
}

export const updateCardPayment: (cardPaymentState: CardPaymentStateModel) => UpdateCardPaymentAction = (cardPaymentState: CardPaymentStateModel) => ({
    type: PaymentActionTypes.UPDATE_CARD_PAYMENT,
    cardPaymentState
});
updateCardPayment[ACTION_CREATOR_NAME] = 'updateCardPayment';

export type UpdateCardPaymentFunc = (...args: Parameters<typeof updateCardPayment>) => void;

export function* updateCardPaymentSaga({ cardPaymentState }: UpdateCardPaymentAction): BasketSagaReturnType {
    yield put<PaymentActions>({
        type: PaymentActionTypes.UPDATE_CARD_PAYMENT_START
    });

    let state: AppState = yield select();

    let paymentDetails = {
        ...state.paymentState.paymentDetails,
        cashCardDeposit: cardPaymentState.deposit,
        cashCardPercentage: cardPaymentState.percentage,
        total: state.basketState.basket!.totalPriceWithTax.value
    };

    try {
        let sessionId = userHelper.getSessionId();
        let username = userHelper.getCurrentUserName();

        yield api.hybris.savePaymentDetails(username, sessionId!, paymentDetails);

        yield put<PaymentActions>({
            type: PaymentActionTypes.UPDATE_CARD_PAYMENT_SUCCESS,
            cardPaymentState,
            paymentDetails
        });

        return true;
    } catch (error) {
        yield put<PaymentActions>({
            type: PaymentActionTypes.UPDATE_CARD_PAYMENT_ERROR,
            error: errorToBasketErrorModel(error, 'updateCardPaymentSaga')
        });

        return false;
    }
}